// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3xLkT","footer":"ModalFilter_footer__9j05s"};